import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Typography, Button, Spinner } from "@material-tailwind/react";
import { add_subscription_data, } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


export const SubscriptionModal = () => {
    const { isModalLoading, setFormData, setDeleteUpdateTag, deleteUpdateYes, handleFileInput, setIsModalLoading, handleClose, formData, open, addEditDeleteTag, handleChange } = useContext(NewContext);


    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData })
    }, [addEditDeleteTag]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdatesubscription;
        setIsModalLoading(true);
        const obj = {
            ...formData,
            subscriptionImage: formData?.subscriptionImage ? formData?.subscriptionImage : [],
        }
        // eslint-disable-next-line eqeqeq
        if (addEditDeleteTag == `add`) {
            createUpdatesubscription = await add_subscription_data(obj)
        } else {
        }

        setIsModalLoading(false);
        if (createUpdatesubscription) {
            const { message, status } = createUpdatesubscription;
            if (status) {
                toast.success(message);
                handleClose();
                setDeleteUpdateTag(deleteUpdateYes);
            } else {
                toast.error(message);
            };
        }
    }


    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "490px",
                            borderRadius: "12px" // Set your width here
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Subscription ` : `Add Subscription `
                    }

                </DialogTitle>

                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form">
                                    {
                                        addEditDeleteTag === `add` ? <div className="col-span-6 sm:col-span-6">
                                            <label htmlFor="subscriptionImage" className="block text-sm font-medium leading-6 text-gray-900"> <p>Upload Subscriptions <sup className='text-red-600'>*</sup> :</p> </label>
                                            <div className="mt-1.5 relative">
                                                {
                                                    <input id='subscriptionImage' type='file' accept="image/png, image/jpeg , image/webp" name='subscriptionImage' onChange={e => handleFileInput(e)} className='w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' multiple required />
                                                }
                                            </div>
                                        </div> : null
                                    }
                                </div>
                                <div className="col-span-6 sm:col-span-6">
                                    <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900"><p>Name <sup className='text-red-600'>*</sup> :</p> </label>
                                    <div className="mt-2">
                                        <input className='w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' id='name' placeholder='Enter name' name='name' onChange={handleChange} value={formData?.name} autoComplete='false' required />
                                    </div>
                                </div>
                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={handleClose}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default SubscriptionModal
